import { Role } from 'types/types';
import { ROLES } from 'variables';

export const roleDescription = (role: Role) => {
  return ROLES[role ?? 'STANDARD'];
};
